import { render, staticRenderFns } from "./CheckoutPassageOfTitle.vue?vue&type=template&id=07a72256&"
import script from "./CheckoutPassageOfTitle.vue?vue&type=script&lang=js&"
export * from "./CheckoutPassageOfTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports